import React, { FunctionComponent, useState, useRef, ReactElement, MutableRefObject } from 'react'
import axios, { AxiosResponse } from 'axios'
import ReCAPTCHA from 'react-google-recaptcha'
import EshopForm from '../sib-forms/eshops'
import PresentationForm from '../sib-forms/presentationwebs'
import ResearchForm from '../sib-forms/research'
import OnlineForm from '../sib-forms/online'
import LandingPageForm from '../sib-forms/landingPage'
import StudioForm from '../sib-forms/studio'
import ContentForm from '../sib-forms/content'
import EnterpriseForm from '../sib-forms/enterprise'
import PortalsForm from '../sib-forms/portals'
import GeneralForm from '../sib-forms/general'
import { t } from 'ttag'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

let { LOCALE } = process.env
LOCALE = LOCALE ? LOCALE : `cs`

export interface FormBuilderPros {
  formId: string
  recaptchaUrl: string
}

export interface FormProps {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  sending: boolean
  locale: string
}

async function validateHuman(token: string | undefined | null, recaptchaUrl: string): Promise<boolean> {
  const url = recaptchaUrl + token
  const human: AxiosResponse<boolean> = await axios.get(url)
  return human.data
}

const FormBuilder: FunctionComponent<FormBuilderPros> = ({ formId, recaptchaUrl }) => {
  const [isSent, setSent] = useState(false)
  const [sending, setSending] = useState(false)
  // const [token, setToken] = useState('')
  const { executeRecaptcha } = useGoogleReCaptcha()

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setSending(true)

    const formEl: HTMLFormElement | null = e.target
    const formData = formEl != null ? new FormData(formEl) : null
    const url: string | undefined = formEl.getAttribute(`action`)
      ? formEl.getAttribute(`action`) + `?isAjax=1`
      : undefined
    const token = await executeRecaptcha()
    const isHuman = await validateHuman(token, recaptchaUrl)

    if (isHuman) {
      axios({
        method: `post`,
        url: url,
        data: formData,
      })
        .then(function (response) {
          setSending(false)
          if (response.data.success) {
            setSent(true)
            dataLayer.push({ event: `sendForm` })
          }
        })
        .catch(function (response) {
          setSending(false)
          alert(`something went wrong, please try again`)
        })
    } else {
      alert(`reCAPTCHA must be solved!`)
      setSending(false)
    }
  }

  const formProps: FormProps = {
    handleSubmit: handleSubmit,
    sending: sending,
    locale: LOCALE,
  }

  const renderSwitchForm = (form: string): ReactElement | null => {
    switch (form) {
      case `eshop`:
        return <EshopForm {...formProps} />
      case `presentations`:
        return <PresentationForm {...formProps} />
      case `research`:
        return <ResearchForm {...formProps} />
      case `online`:
        return <OnlineForm {...formProps} />
      case `studio`:
        return <StudioForm {...formProps} />
      case `content`:
        return <ContentForm {...formProps} />
      case `enterprise`:
        return <EnterpriseForm {...formProps} />
      case `portals`:
        return <PortalsForm {...formProps} />
      case `landingPage`:
        return <LandingPageForm {...formProps} />
      default:
        return <GeneralForm {...formProps} />
    }
  }

  return (
    <>
      {isSent ? <div className="form-success-message">{t`PuxDesign.Form.SuccessMsg`}</div> : renderSwitchForm(formId)}
    </>
  )
}

export default FormBuilder
